// extracted by mini-css-extract-plugin
module.exports = {"indicator":"indicator__QHqOx","question-number":"question-number__2Si2_","separator":"separator__UlL0R","total-questions":"total-questions__2XnFv"};